import React from 'react';
import './LoadingState.scss';

/**
 * Loading state component
 * @param {Object} props
 * @param {string} props.message - Loading message
 * @param {string} props.size - Loader size ('small', 'medium', 'large')
 * @param {boolean} props.fullHeight - Whether to occupy full container height
 */
const LoadingState = ({ 
  message = 'Loading...', 
  size = 'medium',
  fullHeight = true 
}) => {
  return (
    <div className={`loading-state ${fullHeight ? 'full-height' : ''}`}>
      <div className="loading-content">
        <div className={`loading-spinner ${size}`} aria-label="Loading"></div>
        <p className="loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingState;